import { faClock } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card } from 'primereact/card'
import { Chart } from 'primereact/chart'
import React, { useMemo } from 'react'
import './dashboard-hourly-chart.scss'

export interface DashboardHourlyChartProps {
  hourlyCounts: number[]
}

const DashboardHourlyChart: React.FC<DashboardHourlyChartProps> = ({
  hourlyCounts,
}) => {
  const chartData = useMemo(
    () => ({
      labels: hourlyCounts.map((_, hour) => `${hour}h`),
      datasets: [
        {
          label: 'Detecções',
          data: hourlyCounts,
          backgroundColor: 'rgba(34, 211, 238, 0.35)',
          borderColor: '#22d3ee',
          borderWidth: 1,
          borderRadius: 4,
          hoverBackgroundColor: 'rgba(34, 211, 238, 0.6)',
        },
      ],
    }),
    [hourlyCounts]
  )

  const chartOptions = useMemo(
    () => ({
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
      },
      scales: {
        x: {
          ticks: { color: '#94a3b8', maxRotation: 0, autoSkip: true },
          grid: { display: false },
        },
        y: {
          beginAtZero: true,
          ticks: { color: '#94a3b8', precision: 0 },
          grid: { color: 'rgba(148, 163, 184, 0.12)' },
        },
      },
    }),
    []
  )

  const hasData = hourlyCounts.some((count) => count > 0)

  return (
    <Card className='hourly-chart-card'>
      <div className='section-header mb-3'>
        <h3 className='section-title'>
          <FontAwesomeIcon
            icon={faClock}
            className='mr-2'
          />
          Detecções por Hora do Dia
        </h3>
        <p className='section-subtitle'>
          Quando o movimento se concentra no período selecionado
        </p>
      </div>
      {hasData ? (
        <div className='hourly-chart-wrapper'>
          <Chart
            type='bar'
            data={chartData}
            options={chartOptions}
          />
        </div>
      ) : (
        <div className='hourly-chart-empty'>Sem detecções no período</div>
      )}
    </Card>
  )
}

export default DashboardHourlyChart
